import React from 'react';
import * as Yup from 'yup';
import { useField, Form } from '@hum/common/src/modules/form';
import { URL_REGEX } from '@hum/icm-app/src/utils/url';
import { Fieldset, TextInputField } from '@hum/legacy-ui';

export type AddPortfolioInvestorForm = {
  name: string;
  website: string;
};

export const initialValues = {
  name: '',
  website: '',
};

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Company name is required'),
  website: Yup.string()
    .trim()
    .matches(URL_REGEX, 'Please enter a valid URL')
    .required('Website is required'),
});

type Props = {
  form: Form<AddPortfolioInvestorForm>;
  includePosition?: boolean;
  showDescriptionFields?: boolean;
};

export const FormFields = ({ form }: Props) => {
  return (
    <>
      <Fieldset label="Investor Overview">
        <TextInputField
          label="Company Name"
          {...useField('name', 'text', form).input}
          inputTestId="company-name"
        />
        <TextInputField
          label="Company Website"
          {...useField('website', 'text', form).input}
          inputTestId="company-website"
        />
      </Fieldset>
    </>
  );
};
